export default {
    created() {
    },
    mounted() {
        
    },
    methods: {
        handleScroll() {
            let _this = this;
            const refArray = this.refArray || [];
            refArray.forEach((r) => {
                _this.gdjz(r.ref, r.offset || 80, () => {
                _this[r.show] = true
                })
            })
        },
        gdjz (div, offset, callback) {
            let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
            if(dom){
                var a,b,c,d;
                d = this.getElementTop(dom); // 元素距离相对父级的高度，这里父级指的是body
                a = eval(d + offset)
                b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
                c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
                if( b + c > a ) {
                    callback && callback()
                }
            }
        },
        getElementTop(element){
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (current !== null){
                actualTop += current.offsetTop;
                current = current.offsetParent;
            }
            return actualTop;
        },
    },
};
